export default __webpack_public_path__ + "static/media/search.cb774d29.svg";